// eslint-disable-next-line import/prefer-default-export
export const shareASaleRequestUrl = (trackingId: number, xtype: string): string =>
  // eslint-disable-next-line max-len
  `https://www.shareasale.com/sale.cfm?tracking=${trackingId}&amount=0.00&merchantID=114185&transtype=lead&xtype=${xtype}`;
